import { CreateEvent } from "../CreateEvent/CreateEvent";
import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { EventOrganizer } from "../../types/types";
import { checkAuth, getAuthToken } from "../../utils/utils";
import { API_BASE } from "../../config/api";

export const EditEvent = () => {
  const [event, setEvent] = useState<EventOrganizer>();
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);
  const { id } = useParams();
  const url = `${API_BASE}`;
  const navigate = useNavigate();

  if (!checkAuth()) navigate("/registrationPage");
  const token = getAuthToken();

  useEffect(() => {
    if (!id || id.trim() === "") {
      navigate("/");
    }
  }, [id, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await fetch(`${url}/events/${id}/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json());

        if (
          !data ||
          data.length === 0 ||
          data.detail === "Событие не найдено."
        ) {
          throw new Error("Событие не найдено");
        }

        setEvent(data);
        console.log("Событие:", data);
      } catch (error: any) {
        console.error("Ошибка загрузки данных:", error);
        setError(error.message || "Ошибка при загрузке данных");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, token, url]);

  useEffect(() => {
    if (error && error !== "Событие не найдено") {
      alert(error);
      navigate("/");
    }
  }, [error, navigate]);

  if (loading) return <Loader />;
  if (!event || error === "Событие не найдено") {
    navigate("/404");
    return null;
  }
  if (!event.is_owner) {
    navigate(`/event/${id}`);
  }

  // if (event.review_data === null) {
  //   event.review_data = { id: 0, url: "" };
  // }

  return <CreateEvent editableEvent={event} />;
};
